import * as React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import './Footer.css';
import { useSelector } from 'react-redux';
import { Grid } from '@mui/material';

export default function Footer() {
  const isLoading = useSelector((state) => state.isLoading);

  return (
    <div style={{display:'flex',flexDirection:'column',marginLeft:'8px'}}>
      <h4 style={{fontWeight:'300'}}>Legend:</h4>
    <Box 
      display="flex" 
      justifyContent="center" 
      alignItems="stretch" 
      marginTop="5px" 
      gap={2}
    >
      {/* First Card */}
      <Card sx={{ flex: 1, display: 'flex', flexDirection: 'column' ,paddingTop:'15px',paddingLeft:'25px',gap:'5px'}}>
        <CardContent sx={{ flex: 1 }}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <div style={{ height: '15px', width: '15px', backgroundColor: '#43a047', marginRight: '8px' }}></div>
                <div style={{ fontSize: '.9rem' }}>Strong Buy</div>
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <div style={{ height: '15px', width: '15px', backgroundColor: '#81c784', marginRight: '8px' }}></div>
                <div style={{ fontSize: '.9rem' }}>Buy</div>
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <div style={{ height: '15px', width: '15px', backgroundColor: '#1b5e20', marginRight: '8px' }}></div>
                <div style={{ fontSize: '.9rem' }}>Over Bought</div>
              </div>
            </Grid>
            <Grid item xs={6}>
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <div style={{ height: '15px', width: '15px', backgroundColor: '#d32f2f', marginRight: '8px' }}></div>
                <div style={{ fontSize: '.9rem' }}>Strong Sell</div>
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <div style={{ height: '15px', width: '15px', backgroundColor: '#ef5350', marginRight: '8px' }}></div>
                <div style={{ fontSize: '.9rem' }}>Sell</div>
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <div style={{ height: '15px', width: '15px', backgroundColor: '#b71c1c', marginRight: '8px' }}></div>
                <div style={{ fontSize: '.9rem' }}>Over Sold</div>
              </div>
            </Grid>
            <Grid item xs={12} style={{ textAlign: 'center',marginRight:"20px" }}>
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                <div style={{ height: '15px', width: '15px', backgroundColor: '#cfd8dc', marginRight: '8px' }}></div>
                <div style={{ fontSize: '0.9rem' }}>Neutral</div>
              </div>
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      {/* Second Card */}
      <Card sx={{ flex: 1, display: 'flex', flexDirection: 'column',paddingTop:'15px', }}>
        <CardContent sx={{ flex: 1 }}>
          <Grid container spacing={2} alignItems="center" justifyContent="center" style={{ height: '100%' }}>
            <Grid item xs={6} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', textAlign: 'left' }}>
                <div style={{ fontSize: '.9rem' }}>RSL(16)</div>
                <div style={{ fontSize: '.9rem' }}>MACD (12, 26, 9)</div>
                <div style={{ fontSize: '.9rem' }}>STOCHRSI (12, 26, 9)</div>
              </div>
            </Grid>
            <Grid item xs={6} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', textAlign: 'left' }}>
                <div style={{ fontSize: '.9rem' }}>ADX(20,6,12)</div>
                <div style={{ fontSize: '.9rem' }}>Bollinger B(12, 26, 9)</div>
                <div style={{ fontSize: '.9rem' }}>STOCH(12, 26, 9)</div>
              </div>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Box>
    </div>
  );
}


